type OrigSelect = React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>;

export interface SelectProps extends Pick<OrigSelect, Exclude<keyof OrigSelect, 'size'>> {
  id?: string;
  label: React.ReactNode;
  className?: string;
  helpText?: string;
  labelClassName?: string;
  inputClassName?: string;
  style?: React.CSSProperties;
  size?: 'sm' | '' | 'lg';
  error?: boolean;
  required?: boolean;
}

export function Select({
  id,
  size = '',
  className = '',
  style,
  label,
  error = false,
  required = false,
  helpText,
  labelClassName = 'col-12',
  inputClassName = 'col-12',
  children,
  ...props
}: SelectProps) {

  const requiredMarker = required ? (
    <>
        &nbsp;
        <span className="text-danger">*</span>
    </>
) : null;
  
  const helpId = id ? `${id}-help` : '';

  const helpTextClass = error
  ? 'form-text text-danger'
  : 'form-text text-muted';

  const helpTextHtml = helpText && (
    <small id={helpId} className={helpTextClass}>
        {helpText}
    </small>);

  return (
    <div className={`Select ${className}`} style={style}>
      <div className={`form-group row ${error ? 'has-danger' : ''}`}>
        <label htmlFor={id} className={`col-form-label ${labelClassName} ${size ? `col-form-label-${size}` : ''}`}>
          {label}{requiredMarker}
        </label>
        <div className={inputClassName}>
          <select
            {...props}
            className={`form-control ${size ? `form-control-${size}` : ''}`}
            // value="How do I shoot web"
            id={id}
          >
            {children}
          </select>
          {helpTextHtml}
        </div>
      </div>
    </div>
  );
}
